import { render } from "./associated-list.html?vue&type=template&id=4edc1796&scoped=true&ts=true"
import script from "./associated-list.ts?vue&type=script&lang=ts"
export * from "./associated-list.ts?vue&type=script&lang=ts"

import "./associated-list.scss?vue&type=style&index=0&id=4edc1796&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edc1796"]])

export default __exports__